import React from "react";

// Default structure for each row
export const defaultDueDiligenceRows = [
  {
    coreElement:
      "Embedding due diligence in governance, strategy and business model",
    relatedDisclosure: "",
    coversPeople: "",
    coversEnvironment: "",
  },
  {
    coreElement:
      "Engaging with affected stakeholders in all key steps of the due diligence",
    relatedDisclosure: "",
    coversPeople: "",
    coversEnvironment: "",
  },
  {
    coreElement: "Identifying and assessing adverse impacts",
    relatedDisclosure: "",
    coversPeople: "",
    coversEnvironment: "",
  },
  {
    coreElement: "Taking actions to address those adverse impacts",
    relatedDisclosure: "",
    coversPeople: "",
    coversEnvironment: "",
  },
  {
    coreElement:
      "Tracking the effectiveness of these efforts and communicating",
    relatedDisclosure: "",
    coversPeople: "",
    coversEnvironment: "",
  },
];

const DueDiligenceTable = ({ dueDiligenceData, setDueDiligenceData }) => {
  const handleChange = (index, field, value) => {
    const updatedData = [...dueDiligenceData];
    updatedData[index][field] = value;
    setDueDiligenceData(updatedData);
  };

  React.useEffect(() => {
    if (!dueDiligenceData || dueDiligenceData.length === 0) {
      setDueDiligenceData(defaultDueDiligenceRows);
    }
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th
              style={{
                ...tableHeaderStyle,
                textAlign: "left",
                paddingLeft: "20px",
              }}
            >
              CORE ELEMENTS OF DUE DILIGENCE
            </th>
            <th style={tableHeaderStyle}>
              Related Disclosure / Paragraph / Section
            </th>
            <th style={tableHeaderStyle}>Covers Impacts On People (✓)</th>
            <th style={tableHeaderStyle}>Covers Impacts On Environment (✓)</th>
          </tr>
        </thead>
        <tbody>
          {dueDiligenceData.map((row, index) => (
            <tr key={index}>
              <td
                style={{
                  ...tableCellStyle,
                  textAlign: "left",
                  fontWeight: "bold",
                  paddingLeft: "20px",
                }}
              >
                {row.coreElement}
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter the data"
                  value={row.relatedDisclosure}
                  onChange={(e) =>
                    handleChange(index, "relatedDisclosure", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter the data"
                  value={row.coversPeople}
                  onChange={(e) =>
                    handleChange(index, "coversPeople", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter the data"
                  value={row.coversEnvironment}
                  onChange={(e) =>
                    handleChange(index, "coversEnvironment", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (same as before)
const tableHeaderStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default DueDiligenceTable;
